// extracted by mini-css-extract-plugin
module.exports = {"loading__container":"ErrorMessage_loading__container__3vh-h","loading__text":"ErrorMessage_loading__text__3h3nu"};